import { render, staticRenderFns } from "./ColorArrayPicker.vue?vue&type=template&id=1df83ed8&scoped=true&"
import script from "./ColorArrayPicker.vue?vue&type=script&lang=js&"
export * from "./ColorArrayPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorArrayPicker.vue?vue&type=style&index=0&id=1df83ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df83ed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VIcon,VRow,VSpacer})
